import "./LogoSection.scss";
import Logo from "../../assets/logo.png";
import useResponsive from "../../hooks/useResponsive";
import { Button } from "../Button";
import { white } from "../../styles/variables";
import { useNavigate } from "react-router-dom";
import { routes } from "../../Router";

const buttonStyle = {
  position: "absolute",
  backgroundColor: white,
  color: "#FE7C40"
}

const LeftColumn = ({ style, showInstructions }: any) => {
  const navigate = useNavigate();
  const { isDesktopOrLaptop } = useResponsive();

  const onClickInstructions = () => {
    navigate(routes.clientInstructions.path);
  };

  return (
    <div 
      className={
        isDesktopOrLaptop ? "left-column-desktop" : "left-column-mobile"
      }
      style={style}>
      <img alt="logo" src={Logo} className="logo" />
      {showInstructions && <Button style={{
        ...buttonStyle,
        bottom: "10px",
        left: "50%",
        transform: "translateX(-50%)",
      }} onClick={onClickInstructions}>
        INSTRUCCIONES
      </Button>}
    </div>
  );
};

const MobileHeader = ({ showInstructions }: any) => {
  const navigate = useNavigate();

  const onClickInstructions = () => {
    navigate(routes.clientInstructions.path);
  };

  return (
    <div className="mobile-header">
      <img alt="logo" src={Logo} className="logo" />
      {showInstructions && <Button style={{
        ...buttonStyle,
        right: "12px",
      }} onClick={onClickInstructions}>
        INSTRUCCIONES
      </Button>}
    </div>
  );
};

export const LogoSection = ({ style, showInstructions = true }: any) => {
  const { isDesktopOrLaptop } = useResponsive();

  return isDesktopOrLaptop ? <LeftColumn style={style} showInstructions={showInstructions} /> : <MobileHeader showInstructions={showInstructions} />;
};
